import { EPage } from '@types';

export enum ETranslationKeys {
  GENERAL = 'checkout.general',
  CART_PAGE = 'checkout.cartPage',
  UPSELLING_PAGE = 'checkout.upsellingPage',
  RESERVATION_PAGE = 'checkout.reservationPage',
  RESERVATION_PAYMENT_AND_DELIVERY = 'checkout.reservation.paymentAndDelivery',
  LOGIN = 'checkout.login',
  DELIVERY_AND_PAYMENT_PAGE = 'checkout.deliveryAndPaymentPage',
  SUMMARY_PAGE = 'checkout.summaryPage',
  PAYMENT_AND_DELIVERY_PAGE = 'checkout.paymentAndDelivery',
  THANK_YOU_PAGE = 'checkout.thankYouPage',
  ADYEN_REDIRECT_PAGE = 'checkout.adyenRedirectPage',
  GLOBAL_PAYMENTS_REDIRECT_PAGE = 'checkout.globalPaymentsRedirectPage',
  ATTRIBUTE = 'attribute',
  DELIVERY = 'checkout.delivery',
  ERROR = 'checkout.error',
  GOPAY_REDIRECT_PAGE = 'checkout.gopayRedirectPage',
  PRODUCT = 'checkout.product',
  PRZELEWY_REDIRECT_PAGE = 'checkout.przelewyRedirectPage',
  ORDER_GENERAL_MESSAGE = 'order.generalMessage',
  FEATURES = 'checkout.features',
}

export const LOCALIZATION_CONSTANTS: Record<EPage, ETranslationKeys[]> = {
  [EPage.CART]: [
    ETranslationKeys.GENERAL,
    ETranslationKeys.CART_PAGE,
    ETranslationKeys.UPSELLING_PAGE,
    ETranslationKeys.ATTRIBUTE,
    ETranslationKeys.FEATURES,
  ],
  [EPage.UPSELLING]: [ETranslationKeys.UPSELLING_PAGE, ETranslationKeys.GENERAL, ETranslationKeys.ATTRIBUTE],
  [EPage.RESERVATION]: [ETranslationKeys.RESERVATION_PAGE],
  [EPage.RESERVATION_PAYMENT_AND_DELIVERY]: [ETranslationKeys.RESERVATION_PAYMENT_AND_DELIVERY],
  [EPage.HOME_PAGE]: [],
  [EPage.CART_LOG_IN]: [ETranslationKeys.LOGIN],
  [EPage.DELIVERY_AND_PAYMENT]: [
    ETranslationKeys.DELIVERY_AND_PAYMENT_PAGE,
    ETranslationKeys.GENERAL,
    ETranslationKeys.DELIVERY,
    ETranslationKeys.ERROR,
    ETranslationKeys.PRZELEWY_REDIRECT_PAGE,
    ETranslationKeys.ORDER_GENERAL_MESSAGE,
  ],
  [EPage.PAYMENT_AND_DELIVERY]: [ETranslationKeys.PAYMENT_AND_DELIVERY_PAGE],
  [EPage.THANK_YOU]: [ETranslationKeys.THANK_YOU_PAGE, ETranslationKeys.GENERAL],
  [EPage.SUMMARY]: [ETranslationKeys.GENERAL, ETranslationKeys.FEATURES],
  [EPage.REPAY]: [ETranslationKeys.THANK_YOU_PAGE, ETranslationKeys.GENERAL],
  [EPage.LOGIN_PAGE]: [],
  [EPage.REGISTER_PAGE]: [],
  [EPage.BENEFITS_PAGE]: [],
  [EPage.DISCOVERY_BOX]: [],
  [EPage.ADYEN_PAYMENT_REDIRECT_PAGE]: [ETranslationKeys.ADYEN_REDIRECT_PAGE, ETranslationKeys.GENERAL],
  [EPage.GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE]: [
    ETranslationKeys.GLOBAL_PAYMENTS_REDIRECT_PAGE,
    ETranslationKeys.GENERAL,
  ],
  [EPage.GOPAY_PAYMENT_REDIRECT_PAGE]: [ETranslationKeys.GOPAY_REDIRECT_PAGE, ETranslationKeys.GENERAL],
  [EPage.LOYALTY_PROGRAM]: [],
  [EPage.PRZELEWY_PAYMENT_REDIRECT_PAGE]: [ETranslationKeys.PRZELEWY_REDIRECT_PAGE, ETranslationKeys.GENERAL],
};
